import { Component, OnInit } from '@angular/core';
import { ImmoOverviewStateService } from 'src/app/services/immo-overview-state.service';

@Component({
  selector: 'immo-job-overview',
  templateUrl: './immo-job-overview.component.html',
  styleUrls: ['./immo-job-overview.component.scss']
})
export class ImmoJobOverviewComponent implements OnInit {
  selectedOverview: string;

  constructor(
    private immoOverviewStateService: ImmoOverviewStateService
  ) {}

  ngOnInit(): void {
    this.selectedOverview = this.immoOverviewStateService.getSelectedJobOverviewView();
  }

  changeSelectedView(value: string): void {
    this.selectedOverview = value;
    this.immoOverviewStateService.setSelectedJobOverviewView(value);
  }
}
